import { Card, HStack, VStack } from '@chakra-ui/react';
import { getFragmentData } from '@client/graphql/types';
import ApplicationErrorView from '@client/module/error/application-error-view';
import { useFocusedCompanyContext } from '@packages/core/company/focused-company-context';
import { useTranslate } from '@tolgee/react';
import TopBannerCreateModal from './components/top-banner/top-banner-create-modal';
import TopBannerTable from './components/top-banner/top-banner-table';
import { TopBannerFragment } from './logics/top-banner/top-banner-fragment';
import { useTopBanners } from './logics/top-banner/use-top-banners';
import { BannerSkeleton } from './components/banner-skeleton';

export default function TopBanner() {
  const { t } = useTranslate();
  const company = useFocusedCompanyContext();
  const { data, loading, error } = useTopBanners(company.id);

  if (loading) {
    return <BannerSkeleton />;
  }

  const topBannerData = getFragmentData(TopBannerFragment, data?.topBanners);

  return (
    <Card.Root maxW="5xl" rounded="lg" shadow={'xs'}>
      <Card.Header borderBottom="1px solid" borderColor="gray.200" py="5">
        <HStack justify="space-between" align="start">
          <VStack align="start" gap={'4'}>
            <Card.Title fontSize="2xl" fontWeight="bold" color="gray.800">
              {t('top-banner.title', 'Top Banner')}
            </Card.Title>
          </VStack>
          <TopBannerCreateModal />
        </HStack>
      </Card.Header>
      <Card.Body p={0}>
        <ApplicationErrorView error={error} />
        <TopBannerTable data={topBannerData ?? []} />
      </Card.Body>
    </Card.Root>
  );
}
